export default __webpack_public_path__ + "navigation-examples-route-init-thumbnail-v1-960-3bd675b614916165b16d64d815425ea4.png";